var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownsideLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 226,
    viewBox: "0 0 298 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M-25 68.3299C-25 68.3299 39.5989 1.47269 74.6903 51.7004C109.782 101.928 -106.956 313.181 74.6903 187.84C256.336 62.4997 264.451 156.434 264.831 165.731C265.211 175.028 264.831 237 264.831 237",
    stroke: "white",
    strokeWidth: 66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownsideLeft);
export default __webpack_public_path__ + "static/media/downside-left.5c31a02d2d1c3b8e91d046655fef3c67.svg";
export { ForwardRef as ReactComponent };